module.exports = "https://dev.stanwinstonschool.com/avatar_poster_org Large.de38e407bab39a173e7325a09f0c29e9.jpeg";